module.exports = __webpack_public_path__ + "d7fdf9ec81b259a481e7d8da29170d7b.svg";